module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2025-04-24 at 17.25.18_2d9a259a.a69a2f6b.jpg";